import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './font.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import "bootstrap/dist/js/bootstrap.bundle.min";
import 'bootstrap-icons/font/bootstrap-icons.css';
import { UserProvider } from './contexts/UserContext';
import { ToastProvider } from './contexts/ToastContext'; 



const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
     <ToastProvider>
    <UserProvider>
    <App />
    </UserProvider>
    </ToastProvider>
  </React.StrictMode>
);

reportWebVitals();
